<div class="appdiv subtool" *ngIf="!showForm">
    <app-toast></app-toast>
    <div style="width: 125%;">
        <h2 translate>Components List</h2>
    </div>
    <div class="appdiv" style="width: 24%;">
        <button mat-raised-button color="primary" (click)="addComponent('Add')" translate>+ Add Component</button>
    </div>
</div>

<div class="hdrpadding d-flex  align-items-center subtool1" *ngIf="showForm">
    <div>
        <button class="back_icon me-2" (click)="navigateToBackPage()">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
    </div>
    <div style="margin: 0% 1%;">
        <h2 class="m-0"><span translate>Components</span> {{action}}</h2>
    </div>
</div>
<div *ngIf="!showForm" class="bg-white p-3 m-2" style="height: 80vh;border-radius: 2%;">
    <div class="frame">
        <div class="table-container">

            <table mat-table [dataSource]="componentlist" class="mat-elevation-z8">

                <!-- Serial Number -->
                <ng-container matColumnDef="sl.no">
                    <th mat-header-cell *matHeaderCellDef translate>Sl. No.</th>
                    <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
                </ng-container>
                <!-- Info -->
                <ng-container matColumnDef="Title">
                    <th mat-header-cell *matHeaderCellDef translate>Component Name</th>
                    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>
                <!-- Images -->
                <ng-container matColumnDef="images" CdkDragPreview>
                    <th mat-header-cell *matHeaderCellDef translate>Image</th>
                    <td mat-cell *matCellDef="let element">
                        <img [src]="this.accessUrl + '/' + element.image_url" alt="Banner Image" class="banner-image"
                            (click)="OpenImg(this.accessUrl + '/' + element.image_url)" />
                    </td>
                </ng-container>
                <!-- status -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef translate>Status</th>
                    <td mat-cell *matCellDef="let element"
                        [ngClass]="element.status === 'ACTIVE'?  'status-active': 'status-inactive'">{{ element.status
                        }}</td>
                </ng-container>
                <!-- Actions -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef translate>Actions</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="d-flex align-items-center">
                            <div class="action_button" [matMenuTriggerFor]="menu" aria-label="Actions">
                                <i class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                        </div>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item class="update_button" (click)="updateComponent(element, 'Update')" translate>
                                <!-- <mat-icon>edit</mat-icon> -->
                                Update
                            </button>
                            <!-- <button mat-menu-item class="delete_button" (click)="deleteComponent(element.id)">
                            <mat-icon>delete</mat-icon> Delete
                        </button> -->
                            <button mat-menu-item class="delete_button"
                                (click)="EDComponent(element.id, element.status)" translate>
                                <!-- <mat-icon>delete</mat-icon>  -->
                                Enable/Diseble
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <!-- Update Table Header and Row -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    </div>

    <div class="mt-2 pagination" *ngIf="total_count > 5">
        <app-pagination style="width: 100%;" [datafromparent]="total_count"
            (onDatePicked)="pagination($event)"></app-pagination>
    </div>
</div>

<div *ngIf="showForm" class="bg-white mt-2 subtool1" style="height: 76vh;border-radius: 2%;">
    <app-componentadd [questions]="questions" [form]="form" [editdata]="editdata" (submitForm)="onFormSubmit($event)"
        (cancel)="navigateToBackPage()"></app-componentadd>
</div>